import React from 'react';
import { Paper, Box, Typography, Button } from '@mui/material';

const MySettingCard = ({
  icon,
  title,
  description,
  status = 'enabled',
  onToggleClick,
  showToggle = false,
  onClick,
}) => {
  return (
    <Paper
      elevation={3}
      onClick={onClick}
      sx={{
        p: 3,
        borderRadius: 3,
        cursor: onClick ? 'pointer' : 'default',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        backgroundColor: '#fff',
        transition: 'box-shadow 0.3s ease',
        border: '1px solid #fff',
        '&:hover': {
          boxShadow: onClick ? '0 6px 20px rgba(0,0,0,0.12)' : 'none',
          backgroundColor: '#fff',
          border: '1px solid #0076FE',
        },
      }}
    >
      <Box mb={2} sx={{ color: '#1976d2', fontSize: 40, display: 'flex', justifyContent: 'center' }}>
        {icon}
      </Box>

      <Typography
        fontWeight={600}
        gutterBottom
        sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '16px', color: '#1A1F36', }}
      >
        {title}
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        flexGrow={1}
        mb={1}
        sx={{ minHeight: 48, lineHeight: 1.4, fontSize: '12px', color: '#9095A1' }}
      >
        {description}
      </Typography>

      {showToggle && (
        <Button
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onToggleClick && onToggleClick();
          }}
          sx={{
            borderRadius: '20px',
            textTransform: 'capitalize',
            background: status === 'enabled' ? '#fff' : '#0076FE',
            color: status === 'enabled' ? '#595959' : '#fff',
            border: status === 'enabled' ? '1px solid #D5D5D5' : '1px solid #0076FE',
            fontWeight: 500,
            fontSize: 14,
            alignSelf: 'flex-start',
            minWidth: 110,
            px: 2,
            py: 0.7,
            boxShadow: 'none',
            margin: 'auto',
            '&:hover': {
              boxShadow: 'none',
            },
          }}
        >
          {status === 'enabled' ? 'Disable' : 'Enable'}
        </Button>
      )}
    </Paper>
  );
};

export default MySettingCard;
